export const isInViewport = (element?: HTMLElement, offset = 0) => {
  if (!element) return false;
  const top = element.getBoundingClientRect().top;
  return (
    top + offset - element.offsetHeight >= 0 &&
    top - offset + element.offsetHeight <= window.innerHeight
  );
};
